import { observer } from 'mobx-react-lite'
import React from 'react'

import s from './ChatModalHeader.module.scss'

interface ChatHeaderProps {
  title: string
  caption?: string
}

export const ChatHeader: React.FC<ChatHeaderProps> = observer(({ title, caption }) => {
  return (
    <div className={s.header}>
      <div className={s.wrapper}>
          <h3 className={s.title}>{title}</h3>
          <span className={s.caption}>{caption}</span>
      </div>
    </div>
  )
})
